import React, { useCallback, useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import OtherService from '../services/Other'
import EventCard from '../component/EventCard'
import ColorCalender from '../assets/images/calendar.png'
import LocationPin from '../assets/images/map-pin.png'
import PrimaryGradientButton from '../component/PrimaryGradientButton'
import { useNavigate } from 'react-router-dom'
import ModalComponent from '../component/ModalComponent'
import Loader from '../component/Loader'
import newsDefaultImage from '../assets/images/newsDefault.png'
import AdminLayout from '../component/AdminLayout'
import toast from 'react-hot-toast'
import NoData from '../component/NoData'

const EventListing = () => {

    //Date Format Change
    const formatDate = (dateString) => {

        const date = new Date(dateString)
        let dd = date.getDate();
        let mm = parseInt(date.getMonth());
        let yyyy = date.getFullYear()
        mm++;
        mm += ""
        dd += ""
        if (mm.length < 2)
            mm = '0' + mm;
        if (dd.length < 2)
            dd = '0' + dd;

        return `${dd}-${mm}-${yyyy}`

    };
    //All UseState
    const [isEvent, setIsEvent] = useState([])
    const [isEventData, setIsEventData] = useState(false)
    const [searchTerm, setSearchTerm] = useState('')
    const [filteredEvents, setFilteredEvents] = useState([]);
    const [isEventList, setIsEventList] = useState(true)
    const [visibleItemCount, setVisibleItemCount] = useState(12);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [loading, setLoading] = useState(true);
    //Read More Data Modal Display
    const [isModalOpen, setIsModalOpen] = useState(false)
    //UseEffects
    const fetchData = useCallback(async () => {
        try {
            const userInfo = JSON.parse(localStorage.getItem("userData"));
            
            const response = await OtherService.eventListByHierarchyId(userInfo.dcm_hierarchies_id);
            if (response.error == false && response.data.data.length > 0) {
                setIsEvent(response.data.data)
                setFilteredEvents(response.data.data)
                setLoading(false)
                setIsEventData(false)
            }
            else {
                setLoading(false)
                setIsEventData(true)
            }

        }
        catch (error) {
            console.error("error");
        }
    }, []);
    useEffect(() => {
        
        fetchData();

    }, [])
    //Function
    const handleShowModal = (event) => {
        setSelectedEvent(event);
        setIsModalOpen(true);
    };
    const handleShowMore = () => {
        setVisibleItemCount(prevCount => prevCount + 10);
    };
    const navigate = useNavigate()
    const showInterest = (eventId) => {
        const contactId = JSON.parse(localStorage.getItem("userData")).dcm_contacts_id;
        
        const payload = {
            eventId: eventId + '',
            contactId: contactId + '',
          };
          setLoading(true);
          OtherService.eventParticipate(payload)
            .then(res => {
              setLoading(false);
              if (!res.error) {
                toast.success("You have shown interest");
                fetchData();
              } else {
                toast.error("We cannot proceed with the request");
              }
              // setLoading(false)
            })
            .catch(err => {
              setLoading(false);
            });
    };

    const handleEventCreate = () => {
        navigate(`/event-creation`);
    }
    const handleSearch = () => {
        const filtered = isEvent.filter(event => {
            return event.eventName.toLowerCase().includes(searchTerm.toLowerCase());
        });
        setFilteredEvents(filtered);
    };
    const handleSearchInputChange = (event) => {
        setSearchTerm(event.target.value);
    };
    return (
        <>
            {/* <AdminLayout> */}
                {/* {loading && <Loader />} */}

                <section className='mt-4'>
                    <Container>
                        {/* <Row>
                            <Col xs={12}>
                                <div className='buttonWrap my-4'>
                                    <PrimaryGradientButton buttonText="Create Event" onClick={handleEventCreate} />
                                </div>
                            </Col>
                        </Row> */}
                        {isEventData && 
                        <Row>
                            <Col xs={12}>
                                <NoData />
                            </Col>
                        </Row>}
                        {!isEventData &&
                            <div className='userInfoBox adminEvent'>
                                <Row className='productSearchPanelBox'>
                                    <Col xs={12} lg={4}>
                                        <div className='productSearchPanel mb-3'>
                                            <div className="form-group has-search">
                                                <input
                                                    type="text"
                                                    className="form-control mb-0"
                                                    placeholder="Search"
                                                    value={searchTerm}
                                                    onChange={handleSearchInputChange}

                                                />
                                                <PrimaryGradientButton buttonText='Search' onClick={handleSearch} />
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>

                                    {filteredEvents?.slice(0, visibleItemCount).map((item, index) => {
                                        const { eventId, eventName, eventDesc, eventType, stateName, eventStartDate, eventEndDate, contntArticleDetail } = item
                                        return (
                                            <Col xs={12} md={6} lg={4} key={index}>
                                                <EventCard
                                                    item={item}
                                                    image={item?.contentFilesThumbnailImage == null ? newsDefaultImage : item.contentFilesThumbnailImage}
                                                    eventTitle={eventName}
                                                    eventStartTime={formatDate(eventStartDate)}
                                                    calenderImage={ColorCalender}
                                                    eventEndTime={formatDate(eventEndDate)}
                                                    locationPin={LocationPin}
                                                    // eventDesc={eventDesc}
                                                    eventPlace={stateName}
                                                    eventDesc={eventDesc}
                                                    eventType={eventType}
                                                    isEventList={isEventList}
                                                    onClick={() => showInterest(eventId)}
                                                    onClickReadMore={() => handleShowModal(item)}
                                                />

                                            </Col>

                                        )
                                    })}
                                </Row>
                                {visibleItemCount < isEvent.length && (
                                    <Row className='justify-content-center'>
                                        <Col xs={12} lg={3}>
                                            <PrimaryGradientButton onClick={handleShowMore} buttonText='Show More' />
                                        </Col>
                                    </Row>
                                )}
                            </div>
                        }

                    </Container>
                </section>
                {selectedEvent && (
                    <ModalComponent
                        page="eventReadMore"
                        isModalOpen={isModalOpen}
                        setIsModalOpen={setIsModalOpen}
                        modalTitle={selectedEvent.eventName}
                        modalDescription={selectedEvent.contntArticleDetail === null
                            ? "No Details Description Available" : selectedEvent.contntArticleDetail}
                    />
                )}

            {/* </AdminLayout> */}
        </>
    )
}

export default EventListing